<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :isPrint="isPrint || !!postId"
                         @selectField="handleSelectField"/>

    <!-- 산업안전보건관리비 -->
    <div>
      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>{{ $t('안전·보건예산 항목') }}</h5></vs-col>
      </vs-row>
      <vs-row class="mb-8" style="border:1px solid #cdcdcd;">
        <vs-col>
          <ul class="table table-6" style="border-bottom:none;">
            <li class="header header-bg grid-row">
              <span>{{ $t('항목별') }}</span>
              <span>{{ $t('상세내역') }}</span>
              <span>{{ $t('예산') }}</span>
              <span>{{ $t('당월 사용금액') }}</span>
              <span>{{ $t('누계') }}</span>
              <span>{{ $t('집행률') }}</span>
            </li>

            <!-- 안전보건인건비 -->
            <li class="grid-row" v-for="item in form.inputB" :key="item.label">
              <span class="header-bg">{{ item.label }}</span>
              <span>
                <!-- 상세내역 -->
                <span v-if="isPrint" class="print-input">{{ item.value0 }}</span>
                <ml-input v-else class="w-full" v-model=" item.value0" :readonly="board.readonly || !EnableSave" />
              </span>
              <span>
                <!-- 예산 -->
                <span v-if="isPrint" class="print-input">{{ item.value1 }}</span>
                <ml-input v-else class="w-full" v-model=" item.value1" :readonly="board.readonly || !EnableSave"
                          @keyup="calculateB"/>
              </span>
              <span>
                <!-- 당월 사용금액 -->
                <span v-if="isPrint" class="print-input">{{ item.value2 }}</span>
                <ml-input v-else class="w-full" v-model="item.value2" :readonly="board.readonly || !EnableSave"
                          @keyup="calculateB"/>
              </span>
              <span>
                <!-- 누계 -->
                <span v-if="isPrint" class="print-input">{{ item.value3 }}</span>
                <ml-input v-else class="w-full" v-model="item.value3" :readonly="true"/>
              </span>
              <span>
                <!-- 집행률 -->
                <span v-if="isPrint" class="print-input">{{ item.value4 }}</span>
                <ml-input v-else class="w-full" v-model="item.value4" :readonly="true"/>
              </span>
            </li>

            <!-- 누계 -->
            <li class="grid-row">
              <span class="header-bg">{{ $t('누계') }}</span>
              <span></span>
              <span>
                <!-- 예산 -->
                <span v-if="isPrint" class="print-input">{{ totalInputB.value1 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputB.value1" :readonly="true"/>
              </span>
              <span>
                <!-- 당월 사용금액 -->
                <span v-if="isPrint" class="print-input">{{ totalInputB.value2 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputB.value2" :readonly="true"/>
              </span>
              <span>
                <!-- 누계 -->
                <span v-if="isPrint" class="print-input">{{ totalInputB.value3 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputB.value3" :readonly="true"/>
              </span>
              <span>
                <!-- 집행률 -->
                <span v-if="isPrint" class="print-input">{{ totalInputB.value4 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputB.value4" :readonly="true"/>
              </span>
            </li>
          </ul>
        </vs-col>
      </vs-row>
    </div>
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'


export default {
  components: {
    FieldSelectModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FileUploadModule
  },
  props: {
    tab: Object,
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  computed: {
    myInfo() {
      return this.$store.state.auth.userInfo
    },
    totalInputB() {
      return this.computeInputTotal(this.form.inputB)
    },
    postId() {
      return parseInt(this.$route.params.postId);
    }
  },
  watch: {
    header: {
      immediate: true,
      deep: true,
      handler(/*header*/) {
        this.initTotalB()
      }
    },
    value: {
      deep: true,
      async handler(value) {
        // form 과 같은 데이터 인지 체크
        if (JSON.stringify(value) !== JSON.stringify(this.form)) {
          const keys = Object.keys(this.form)
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key]
            }
          }

          this.calculateB()
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {

        value.summary = {
          안전보건예산_사업장명: [],
          안전보건예산_항목명: []
        }

        let totalBudget = 0
        for (const data of this.form.inputB) {
          totalBudget += Number(this.removeComma(`${data.value1}`))
          value.summary['안전보건예산_항목명'].push({
            [data.label]: Number(this.removeComma(`${data.value1}`))
          })
        }

        value.summary['안전보건예산_사업장명'].push({
          [this.form.stdInfo.field_name]: totalBudget
        })

        this.$emit('input', value)
      }
    },

    EnableSave: {
      immediate: true,
      handler() {
        console.log('EnableSave', this.EnableSave)
        this.$emit("EnableSave", this.EnableSave)
      }
    },
  },
  data() {
    return {
      EnableSave: true,
      oldForm: {},
      form: {
        total: {},
        stdInfo: {},
        fileList: [],
        // 직전 월 까지의 누계
        totalB: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        inputB: [
          {label: '방호장치, 안전장치 구입 비용', value0:'', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '안전보건 관련 물품 및 보호구 등 구입 비용', value0:'', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '위험설비 자동화 등 안전시설 개선 비용', value0:'', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '설비 및 시설물에 대한 안전점검 비용', value0:'', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '안전보건진단, 위탁 및 컨설팅 비용', value0:'', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '작업환경측정 및 특수건강진단 비용', value0:'', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '작업환경개선 및 근골격계 질환 예방 비용', value0:'', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '공상자 치료 및 응급구조 관련 비용', value0:'', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '건강관리실 및 건강증진실 운영 비용', value0:'', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '안전보건교육 훈련 비용', value0:'', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '안전보건관계자 외부교육 및 훈련 비용', value0:'', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '안전보건 포상 비용', value0:'', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '안전보건활동 촉진을 위한 캠페인 등 지원 비용', value0:'', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '안전보건조직 운영 및 재해예방 인력 비용', value0:'', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '협력업체 지원 비용', value0:'', value1: 0, value2: 0, value3: 0, value4: 0.0},
          {label: '기타(산업안전보건관리비)', value0:'', value1: 0, value2: 0, value3: 0, value4: 0.0},
        ],
      }
    }
  },
  mounted() {
    this.initTotalB()
  },
  methods: {
    async initTotalB() {
      const postId = this.$route.params.postId
      if (!postId) {
        await this.loadListBoard()
        this.calculateB()
      }
    },
    handleSelectField() {
      this.initTotalB()
    },
    computeInputTotal(inputSet) {
      const inputTotal = {label: '누계', value1: 0, value2: 0, value3: 0, value4: 0}

      for (const inputB of inputSet) {
        inputTotal.value1 += Number(this.removeComma(inputB.value1) ? this.removeComma(inputB.value1) : 0)
        inputTotal.value2 += Number(this.removeComma(inputB.value2) ? this.removeComma(inputB.value2) : 0)
        inputTotal.value3 += Number(this.removeComma(inputB.value3) ? this.removeComma(inputB.value3) : 0)
      }

      // NaN 방지
      if (inputTotal.value1 > 0) {
        inputTotal.value4 = Math.floor(inputTotal.value3 * 10000.0 / inputTotal.value1) / 100
      } else {
        inputTotal.value4 = 0
      }

      inputTotal.value1 = this.comma(inputTotal.value1)
      inputTotal.value2 = this.comma(inputTotal.value2)
      inputTotal.value3 = this.comma(inputTotal.value3)

      this.form.total = inputTotal
      return inputTotal
    },
    async loadListBoard() {
      // 직전 월 까지의 누계
      const 직전월누계 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

      /**
       * 만약 대상 사업장이 선택되지 않았다면, 값을 0으로 초기화하고, "저장" 기능을 비활성화한다
       */
      if (!this.form.stdInfo.field_id) {
        this.EnableSave = false;
        for (let i = 0; i < this.form.inputB.length; i++) {
          this.form.inputB[i].value0 = '';
          this.form.inputB[i].value1 = 0;
          this.form.inputB[i].value2 = 0;
          this.form.inputB[i].value3 = 0;
          this.form.inputB[i].value4 = 0;
          직전월누계[i] = 0;
        }
        this.form.totalB = 직전월누계
        return;
      }

      // 페이지 헤더에서 선택된 날짜
      const selectedDate = `${this.header.year}-${this.header.month.toString().padStart(2, '0')}-01`;

      const projectId = this.$route.params.proj_id
      const boardId = 106
      const page = 1
      const perPage = 1000
      const dateTarget = 'header.full'
      const dateBegin = `${this.header.year}-01-01`
      const dateEnd = `${Number(this.header.year) + 1}-01-01`
      const keyword = [`content$body.stdInfo.field_id*${this.form.stdInfo.field_id}`];

      // 선택된 년도 내에서 작성된 글을 검색한다
      const conditions = [];
      conditions.push({key: dateTarget, operator: '>=', value: dateBegin})
      conditions.push({key: dateTarget, operator: '<', value: dateEnd})

      await this.$store.dispatch('board/LOAD_POST_LIST', {
        boardId,
        projectId,
        page,
        perPage,
        keyword,
        conditions,
      })
      const rows = [...JSON.parse(JSON.stringify(this.$store.state.board.list))]


      /**
       * 해당 년도에 작성된 글이 존재할 경우
       */
      if (rows.length > 0) {
        const postDataList = [];
        for (const data of rows) {
          if (data.post_content) {
            const content = JSON.parse(data.post_content)
            postDataList.push({ header: content.header, body: content.body })
          }
        }

        // 검색된 데이터를, header.full 오름차순으로 정렬한다
        const sortedPostDataList = postDataList.sort(function (a, b) {
          const x = new Date(a.header.full).getTime();
          const y = new Date(b.header.full).getTime();

          if (x < y) return -1;
          if (x > y) return 1;
          return 0;
        })

        // 작성된 글 중에서, 선택된 날짜와 가장 가까운 과거의 데이터를 추출한다
        let lastMonthPostData = {};
        let lastMonthBudgetItems = [];
        // 작성되 글 중에서, 선택된 날짜와 동일한 데이터를 추출한다
        let currentMonthPostData = {};
        let currentMonthBudgetItems = [];
        for (const data of sortedPostDataList) {
          if (new Date(data.header.full).getTime() < new Date(selectedDate).getTime()) {
            lastMonthPostData = data;
            if (data.body && data.body.inputB) {
              lastMonthBudgetItems = data.body.inputB;
            }
          }
          if (new Date(selectedDate).getTime() === new Date(data.header.full).getTime()) {
            currentMonthPostData = data;
            if (data.body && data.body.inputB) {
              currentMonthBudgetItems = data.body.inputB;
            }
          }
        }


        // 선택된 날짜에 작성된 문서가 존재하고
        if (currentMonthPostData && currentMonthPostData.body) {
          // 해당 날짜에 문서가 존재하면, 저장할 수 없도록 한다.
          this.EnableSave = false;

          for (let i = 0; i < currentMonthBudgetItems.length; i++) {
            this.form.inputB[i].value0 = currentMonthBudgetItems[i].value0;
            this.form.inputB[i].value1 = this.convNumber(currentMonthBudgetItems[i].value1 /*예산*/);
            this.form.inputB[i].value2 = this.convNumber(currentMonthBudgetItems[i].value2 /*당월 사용금액*/);
            this.form.inputB[i].value3 = this.convNumber(currentMonthBudgetItems[i].value3 /*누계*/);
            this.form.inputB[i].value4 = this.convNumber(currentMonthBudgetItems[i].value4 /*집행률*/);

            if (lastMonthBudgetItems && lastMonthBudgetItems.length > 0 && lastMonthBudgetItems[i]) {
              const 직전월사용금액 = this.convNumber(lastMonthBudgetItems[i].value2 || 0);
              const 직전직전월누계 = this.convNumber(lastMonthBudgetItems[i].value3 || 0);
              직전월누계[i] = 직전월사용금액 + 직전직전월누계;
            } else {
              직전월누계[i] = 0;
            }
          }
        }
        // 선택된 년월의 데이터가 없고, 직전년월 데이터가 존재할 경우
        else if (lastMonthPostData && lastMonthPostData.body) {
          this.EnableSave = true;

          for (let i = 0; i < lastMonthBudgetItems.length; i++) {
            this.form.inputB[i].value0 = '';
            this.form.inputB[i].value1 = this.convNumber(lastMonthBudgetItems[i].value1);
            this.form.inputB[i].value2 = 0;
            this.form.inputB[i].value3 = this.convNumber(lastMonthBudgetItems[i].value3);
            this.form.inputB[i].value4 = 0;

            const 직전월사용금액 = this.convNumber(lastMonthBudgetItems[i].value2 || 0);
            const 직전직전월누계 = this.convNumber(lastMonthBudgetItems[i].value3 || 0);
            직전월누계[i] = 직전월사용금액 + 직전직전월누계;
          }
        }
        // 선택된 년월의 데이터가 없고, 직전년월 데이터도 없을 경우
        else {
          this.EnableSave = true;

          for (let i = 0; i < this.form.inputB.length; i++) {
            this.form.inputB[i].value0 = '';
            this.form.inputB[i].value1 = 0;
            this.form.inputB[i].value2 = 0;
            this.form.inputB[i].value3 = 0;
            this.form.inputB[i].value4 = 0;
            직전월누계[i] = 0;
          }
        }

        this.form.totalB = 직전월누계
      }

      /**
       * 해당 년도에 작성된 글이 존재하지 않을 경우
       */
      else {
        this.EnableSave = true;
        for (let i = 0; i < this.form.inputB.length; i++) {
          this.form.inputB[i].value0 = '';
          this.form.inputB[i].value1 = 0;
          this.form.inputB[i].value2 = 0;
          this.form.inputB[i].value3 = 0;
          this.form.inputB[i].value4 = 0;
          직전월누계[i] = 0;
        }
        this.form.totalB = 직전월누계
      }

      if (!this.form.stdInfo.field_id) {
        this.EnableSave = false;
      }
    },
    calculateB() {
      this.calculateInputs('inputB', 'totalB')
    },
    calculateInputs(inputName, totalName) {
      const inputSet = this.form[inputName]
      const list = []
      for (let i = 0; i < inputSet.length; i++) {
        const inputB = inputSet[i]

        // 콤마 삭제
        const value = {
          label: inputB.label,
          value0: inputB.value0,
          value1: this.removeComma(inputB.value1),
          value2: this.removeComma(inputB.value2),
        }

        // 누계사용금액 계산
        value.value3 = this.convNumber(`${this.form[totalName][i]}`) + Number(`${value.value2}`)

        // 집행률 계산
        if (this.convNumber(`${value.value1}`) > 0) {
          value.value4 = Math.floor(this.convNumber(`${value.value3}`) * 10000.0 / this.convNumber(`${value.value1}`)) / 100
        } else {
          value.value4 = 0
        }
        list.push(value)
      }

      // 콤마 추가
      for (const inputB of list) {
        inputB.value1 = this.comma(inputB.value1)
        inputB.value2 = this.comma(inputB.value2)
        inputB.value3 = this.comma(inputB.value3)
        inputB.value4 = inputB.value4 ? inputB.value4 : '0'
      }
      this.form[inputName] = JSON.parse(JSON.stringify(list))
    },
    comma(str) {
      return `${str}`.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    removeComma(str) {
      if (str) {
        const noneComma = `${str}`.replaceAll(',', '')
        return `${Number(noneComma)}`
      }
      return '0'
    },
    convNumber(str) {
      return Number(this.removeComma(`${str}`))
    },
  },
}
</script>

<style scoped>

</style>
